import { createSelector } from 'reselect';
import { getEntities } from '../../global-selectors';

export const selectDevices = createSelector(
  getEntities,
  (entities) => entities?.devices || []
);
